import { EntityType } from '@frontend/common';

/**
 * Account used for entity-scoped MQTT topics.
 * Prefer the entity's own `account_id` (shared B entities); fall back to the selected account.
 */
export function resolveEntityMqttAccountId(entityAccountId: string | null | undefined, currentAccount: string | null | undefined): string | undefined {
    return entityAccountId ?? currentAccount ?? undefined;
}

/** Per-entity topic: `accounts/{accountId}/{entityType}s/{id}`. */
export function buildEntityMqttTopic(accountId: string, entityType: string, entityId: string): string {
    return `accounts/${accountId}/${entityType}s/${entityId}`;
}

/**
 * Collection / list event topic for an EntityType path segment.
 * ACCOUNT uses the bare `account` topic (legacy).
 */
export function buildCollectionMqttTopic(accountId: string, eventListener: EntityType | string): string {
    if (eventListener === EntityType.ACCOUNT || eventListener === 'account') {
        return 'account';
    }
    return `accounts/${accountId}/${eventListener}`;
}

/**
 * Lists always filter by the selected (A) account. The backend returns owned + shared-into-A rows.
 * Do not pass a foreign entity's account_id here.
 */
export function resolveListQueryAccountId(currentAccount: string | null | undefined, fallback?: string | null): string | null | undefined {
    return currentAccount ?? fallback;
}
